import React, { PropTypes } from 'react';
import Sponsors from './Sponsors';
import Supporters from './Supporters';
import Thankyou from './Thankyou';

const SupportRow = ({ edition, supporters, thankyou, sponsors, editions, lang }) => {
  const color = editions.find(item => item.year === String(edition)).background;
  const style = {
    color,
  };
  return (
    <div className="content-row">
      <div className="support-col support-col--edition">
        <header className="subsection__header">
          <h2 style={style} className="subsection__header__title">{edition}</h2>
        </header>
      </div>
      <div className="support__rest">
        <Supporters lang={lang} data={supporters} />
        <Sponsors lang={lang} data={sponsors} />
        <Thankyou lang={lang} data={thankyou} />
      </div>
    </div>
  );
};

export default SupportRow;

SupportRow.propTypes = {
  edition: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  editions: PropTypes.arrayOf(PropTypes.object).isRequired,
  supporters: PropTypes.arrayOf(PropTypes.object).isRequired,
  thankyou: PropTypes.arrayOf(PropTypes.object).isRequired,
  sponsors: PropTypes.arrayOf(PropTypes.object).isRequired,
};



// WEBPACK FOOTER //
// ./js/components/support/SupportRow.js